import { SelectedShippingRateSchema } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const buyReturnLabel = {
  name: "buyReturnLabel" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    shipmentRate: SelectedShippingRateSchema,
  }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().optional(),
  }),
};
